/* Vendora theme scripts */
(() => {
  const config = window.Vendora || { routes: {}, strings: {} };
  const routes = config.routes;
  const strings = config.strings;

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };
  const store = {
    get(k, d) {
      try {
        const v = localStorage.getItem(k);
        return v ? JSON.parse(v) : d;
      } catch (e) {
        return d;
      }
    },
    set(k, v) {
      try {
        localStorage.setItem(k, JSON.stringify(v));
      } catch (e) {
        /* storage unavailable */
      }
    },
  };

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2600);
  }

  /* ---------- Drawers, search panel, modal ---------- */
  const Drawers = {
    active: null,
    trigger: null,
    open(id, trigger) {
      const el = document.getElementById(id);
      if (!el) return;
      if (this.active && this.active !== el) this.close(false);
      this.trigger = trigger || document.activeElement;
      this.active = el;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => ($('[data-search-input]', el) || $('[data-drawer-close]', el) || el).focus({ preventScroll: true }), 60);
    },
    close(restoreFocus = true) {
      const el = this.active;
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      $$('video', el).forEach((v) => v.pause());
      if (el.id === 'Modal') el.classList.remove('modal--wide');
      const trigger = this.trigger;
      this.active = null;
      this.trigger = null;
      if (restoreFocus && trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    },
    trap(event) {
      if (!this.active || event.key !== 'Tab') return;
      const nodes = $$(FOCUSABLE, this.active).filter((n) => n.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  };

  function openModal(content, trigger, wide = false) {
    const modal = document.getElementById('Modal');
    if (!modal) return;
    const slot = $('[data-modal-content]', modal);
    slot.innerHTML = '';
    if (typeof content === 'string') slot.innerHTML = content;
    else slot.appendChild(content);
    modal.classList.toggle('modal--wide', wide);
    Drawers.open('Modal', trigger);
  }

  /* ---------- Cart ---------- */
  const Cart = {
    sectionIds() {
      return $$('[data-cart-section]').map((el) => el.dataset.sectionId);
    },
    applySections(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const next = parseHTML(html).querySelector('[data-cart-section]');
        const current = $(`[data-cart-section][data-section-id="${id}"]`);
        if (next && current) current.replaceWith(next);
      });
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = !count;
      });
    },
    async refreshCount() {
      try {
        const cart = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        this.updateCount(cart.item_count);
      } catch (e) {
        /* refreshed on next page load */
      }
    },
    async add(body, button, errorEl) {
      const drawer = document.getElementById('CartDrawer');
      if (drawer) {
        body.append('sections', this.sectionIds().join(','));
        body.append('sections_url', window.location.pathname);
      }
      button?.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;
      try {
        const res = await fetch(`${routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await res.json();
        if (data.status) {
          const message = data.description || data.message || strings.error;
          if (errorEl) {
            errorEl.textContent = message;
            errorEl.hidden = false;
          } else {
            toast(message);
          }
          return false;
        }
        if (!drawer) {
          window.location.href = routes.cart;
          return true;
        }
        this.applySections(data.sections);
        await this.refreshCount();
        Drawers.open('CartDrawer', button);
        return true;
      } catch (e) {
        toast(strings.error);
        return false;
      } finally {
        button?.classList.remove('is-loading');
      }
    },
    async change(line, quantity, origin) {
      const section = origin.closest('[data-cart-section]');
      section?.classList.add('is-updating');
      try {
        const res = await fetch(`${routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: this.sectionIds(), sections_url: window.location.pathname }),
        });
        const data = await res.json();
        if (data.status) {
          const err = $('[data-cart-error]', section || document);
          if (err) {
            err.textContent = data.description || data.message || strings.error;
            err.hidden = false;
          }
          return;
        }
        this.applySections(data.sections);
        this.updateCount(data.item_count);
      } catch (e) {
        window.location.reload();
      } finally {
        section?.classList.remove('is-updating');
      }
    },
  };

  async function openQuickAdd(url, trigger) {
    trigger.classList.add('is-loading');
    try {
      const html = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=quick-add`).then((r) => r.text());
      const section = parseHTML(html).querySelector('.quick-add-product');
      if (!section) throw new Error('missing');
      openModal(document.importNode(section, true), trigger, true);
    } catch (e) {
      window.location.href = url;
    } finally {
      trigger.classList.remove('is-loading');
    }
  }

  /* ---------- Wishlist (localStorage) ---------- */
  const Wishlist = {
    key: 'vd-wish',
    list() {
      return store.get(this.key, []);
    },
    has(handle) {
      return this.list().includes(handle);
    },
    toggle(handle) {
      const list = this.list();
      const on = !list.includes(handle);
      const next = on ? [handle, ...list] : list.filter((h) => h !== handle);
      store.set(this.key, next);
      this.paint();
      toast(on ? strings.wishAdded : strings.wishRemoved);
      document.dispatchEvent(new CustomEvent('wishlist:change'));
    },
    paint(root = document) {
      const list = this.list();
      $$('[data-wish]', root).forEach((el) => {
        const on = list.includes(el.dataset.wish);
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-pressed', on);
        const label = $('span', el);
        if (label && el.dataset.wishLabel) label.textContent = on ? el.dataset.wishLabelOn : el.dataset.wishLabel;
      });
      $$('[data-wish-count]').forEach((el) => {
        el.textContent = list.length;
        el.hidden = !list.length;
      });
    },
  };

  /* ---------- Product card swatches + quick sizes ---------- */
  function selectCardColour(swatch) {
    const card = swatch.closest('[data-card]');
    if (!card) return;
    $$('.swatch', card).forEach((s) => s.classList.toggle('is-active', s === swatch));
    const img = $('[data-card-img]', card);
    if (img && swatch.dataset.img) {
      img.removeAttribute('srcset');
      img.src = swatch.dataset.img;
    }
    if (swatch.dataset.url) $$('[data-card-link]', card).forEach((a) => (a.href = swatch.dataset.url));
    const json = $('[data-card-variants]', card);
    const sizes = $('[data-quick-sizes]', card);
    if (json && sizes) {
      const colour = swatch.dataset.swatch;
      const variants = JSON.parse(json.textContent).filter((v) => v.c === colour);
      sizes.innerHTML = '';
      variants.forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'quick__size';
        b.dataset.quickVariant = v.id;
        b.textContent = v.s;
        b.disabled = !v.a;
        sizes.appendChild(b);
      });
      const label = $('[data-quick-color]', card);
      if (label) label.textContent = colour;
    }
  }

  /* ---------- Global events ---------- */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('[data-product-form]')) {
      event.preventDefault();
      const button = $('[type="submit"][name="add"]', form) || event.submitter;
      Cart.add(new FormData(form), event.submitter || button, $('[data-form-error]', form)).then((ok) => {
        if (ok && form.closest('#Modal')) Drawers.active?.id === 'Modal' && Drawers.close(false);
      });
      return;
    }
    if (form.matches('[data-facet-form]')) {
      [...form.elements].forEach((el) => {
        const emptyValue = el.name && el.value === '' && el.type !== 'checkbox';
        const rangeAtMax = el.matches?.('[data-price-range]') && Number(el.value) >= Number(el.max);
        if (emptyValue || rangeAtMax) {
          el.disabled = true;
          el.dataset.tempDisabled = '';
        }
      });
    }
  });

  window.addEventListener('pageshow', () => {
    $$('[data-temp-disabled]').forEach((el) => {
      el.disabled = false;
      delete el.dataset.tempDisabled;
    });
  });

  document.addEventListener('click', (event) => {
    const t = event.target;

    const opener = t.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      Drawers.open(opener.dataset.drawerOpen, opener);
      return;
    }
    const cartOpener = t.closest('[data-cart-open]');
    if (cartOpener && document.getElementById('CartDrawer')) {
      event.preventDefault();
      Drawers.open('CartDrawer', cartOpener);
      return;
    }
    if (t.closest('[data-drawer-close]') || t.matches('[data-overlay]') || t.id === 'Modal') {
      Drawers.close();
      return;
    }

    const lineButton = t.closest('button[data-line][data-quantity]');
    if (lineButton) {
      event.preventDefault();
      Cart.change(lineButton.dataset.line, lineButton.dataset.quantity, lineButton);
      return;
    }

    const quickVariant = t.closest('[data-quick-variant]');
    if (quickVariant) {
      event.preventDefault();
      const body = new FormData();
      body.append('id', quickVariant.dataset.quickVariant);
      body.append('quantity', '1');
      Cart.add(body, quickVariant);
      return;
    }
    const quickAdd = t.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      openQuickAdd(quickAdd.dataset.quickAdd, quickAdd);
      return;
    }

    const wish = t.closest('[data-wish]');
    if (wish) {
      event.preventDefault();
      Wishlist.toggle(wish.dataset.wish);
      return;
    }

    const swatch = t.closest('.swatch[data-swatch]');
    if (swatch) {
      event.preventDefault();
      selectCardColour(swatch);
      return;
    }

    const modalTemplate = t.closest('[data-modal-template]');
    if (modalTemplate) {
      const tpl = document.getElementById(modalTemplate.dataset.modalTemplate);
      if (tpl) openModal(tpl.content.cloneNode(true), modalTemplate);
      return;
    }

    const accordion = t.closest('[data-accordion]');
    if (accordion) {
      const item = accordion.parentElement;
      const open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      accordion.setAttribute('aria-expanded', open);
      return;
    }

    const themeToggle = t.closest('[data-theme-toggle]');
    if (themeToggle) {
      const root = document.documentElement;
      const current = root.dataset.theme || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
      const next = current === 'dark' ? 'light' : 'dark';
      root.dataset.theme = next;
      try {
        localStorage.setItem('vd-theme', next);
      } catch (e) {
        /* ignore */
      }
      return;
    }

    const cols = t.closest('[data-cols]');
    if (cols) {
      const n = cols.dataset.cols;
      $$('[data-cols]').forEach((b) => b.classList.toggle('is-active', b === cols));
      $$('[data-collection-grid]').forEach((g) => g.style.setProperty('--user-cols', n));
      store.set('vd-cols', n);
      return;
    }

    const loadMore = t.closest('[data-load-more-link]');
    if (loadMore) {
      event.preventDefault();
      loadMorePage(loadMore);
      return;
    }

    const share = t.closest('[data-share-url]');
    if (share) {
      if (navigator.share) navigator.share({ url: share.dataset.shareUrl }).catch(() => {});
      else navigator.clipboard?.writeText(share.dataset.shareUrl).then(() => toast(strings.linkCopied));
      return;
    }

    const stage = t.closest('[data-stage]');
    if (stage && !t.closest('button')) stage.classList.toggle('is-zoomed');
  });

  async function loadMorePage(link) {
    link.classList.add('is-loading');
    try {
      const doc = parseHTML(await fetch(link.href).then((r) => r.text()));
      const grid = $('[data-collection-grid]');
      $$('[data-collection-grid] > *', doc).forEach((card) => grid.appendChild(document.importNode(card, true)));
      const next = $('[data-load-more]', doc);
      const current = link.closest('[data-load-more]');
      if (next && current) current.replaceWith(document.importNode(next, true));
      Wishlist.paint(grid);
      history.replaceState({}, '', link.href);
    } catch (e) {
      window.location.href = link.href;
    }
  }

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (t.matches('.qty__input[data-line]')) {
      Cart.change(t.dataset.line, t.value, t);
      return;
    }
    if (t.matches('select[data-autosubmit]')) {
      t.form?.submit();
      return;
    }
    const form = t.form;
    if (form && form.matches('[data-facet-form]')) {
      if (t.closest('.drawer.is-open')) return; // mobile: wait for "Apply"
      form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && Drawers.active) Drawers.close();
    Drawers.trap(event);
  });

  /* ---------- Custom elements ---------- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      const input = $('input', this);
      $$('[data-step]', this).forEach((b) =>
        b.addEventListener('click', () => {
          const min = Number(input.min) || 1;
          input.value = Math.max(min, (Number(input.value) || min) + Number(b.dataset.step));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        })
      );
    }
  }

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.items = $$('[data-media-id]', this);
      $$('[data-thumb]', this).forEach((th) => th.addEventListener('click', () => this.show(th.dataset.thumb)));
      $('[data-gallery-prev]', this)?.addEventListener('click', () => this.step(-1));
      $('[data-gallery-next]', this)?.addEventListener('click', () => this.step(1));
      let x0 = null;
      const stage = $('[data-stage]', this);
      stage?.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
      stage?.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
        x0 = null;
      });
    }
    step(dir) {
      if (!this.items.length) return;
      const i = this.items.findIndex((it) => it.classList.contains('is-active'));
      this.show(this.items[(i + dir + this.items.length) % this.items.length].dataset.mediaId);
    }
    show(id) {
      const target = this.items.find((it) => it.dataset.mediaId === String(id));
      if (!target) return;
      $('[data-stage]', this)?.classList.remove('is-zoomed');
      this.items.forEach((it) => {
        it.classList.toggle('is-active', it === target);
        if (it !== target) $$('video', it).forEach((v) => v.pause());
      });
      $$('[data-thumb]', this).forEach((th) => {
        const on = th.dataset.thumb === String(id);
        th.classList.toggle('is-active', on);
        if (on) th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const json = $('[data-variants]', this);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.requestId = 0;
      this.addEventListener('change', () => this.onChange());
    }
    onChange() {
      const options = $$('fieldset', this).map((fs) => {
        const checked = $('input:checked', fs);
        const label = $('[data-selected-value]', fs);
        if (label && checked) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
      const variant = this.variants.find((v) => v.options.every((val, i) => val === options[i]));
      const sectionId = this.dataset.sectionId;
      const form = document.getElementById(this.dataset.formId);
      const input = form && $('[data-variant-input]', form);
      const buttons = [$(`[data-swap="add-${sectionId}"]`), ...$$(`.sticky-atc [form="${this.dataset.formId}"]`)].filter(Boolean);

      if (!variant) {
        if (input) input.value = '';
        buttons.forEach((b) => {
          b.disabled = true;
          if (b.dataset.swap) b.textContent = strings.unavailable;
        });
        return;
      }
      if (input) input.value = variant.id;
      buttons.forEach((b) => {
        b.disabled = !variant.available;
        if (b.dataset.swap) b.textContent = variant.available ? strings.addToCart : strings.soldOut;
      });
      if (this.hasAttribute('data-update-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      if (variant.featured_media) {
        const scope = this.closest('.product') || document;
        $('media-gallery', scope)?.show(variant.featured_media.id);
        const stickyImg = $('.sticky-atc__img img');
        if (stickyImg && this.hasAttribute('data-update-url') && variant.featured_media.preview_image) {
          stickyImg.removeAttribute('srcset');
          stickyImg.src = variant.featured_media.preview_image.src;
        }
      }
      this.render(variant);
    }
    async render(variant) {
      const sectionId = this.dataset.sectionId;
      const id = ++this.requestId;
      try {
        const doc = parseHTML(await fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${sectionId}`).then((r) => r.text()));
        if (id !== this.requestId) return;
        ['price', 'bnpl', 'stock', 'sticky-price', 'add'].forEach((key) => {
          const sel = `[data-swap="${key}-${sectionId}"]`;
          const next = $(sel, doc);
          const cur = $(sel);
          if (next && cur) cur.replaceWith(next);
        });
        $$('[data-option-label]', doc).forEach((label) => {
          const cur = $(`[data-option-label="${label.dataset.optionLabel}"]`, this);
          cur?.classList.toggle('is-unavailable', label.classList.contains('is-unavailable'));
        });
      } catch (e) {
        /* keep optimistic state */
      }
    }
  }

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('[data-search-input]', this);
      this.results = $('[data-search-results]', this);
      if (!this.input) return;
      this.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-q]');
        if (pill && this.dataset.enabled === 'true') {
          e.preventDefault();
          this.input.value = pill.dataset.q;
          this.search();
        }
      });
      if (this.dataset.enabled === 'true') this.input.addEventListener('input', debounce(() => this.search(), 250));
    }
    async search() {
      const q = this.input.value.trim();
      this.controller?.abort();
      if (!q) {
        this.results.innerHTML = '';
        this.classList.remove('predictive-active');
        return;
      }
      this.controller = new AbortController();
      const params = new URLSearchParams({ q, section_id: 'predictive-search', 'resources[type]': 'product,collection,query,page,article', 'resources[limit]': '6', 'resources[limit_scope]': 'each' });
      try {
        const html = await fetch(`${routes.predictiveSearch}?${params}`, { signal: this.controller.signal }).then((r) => r.text());
        const res = $('[data-predictive-results]', parseHTML(html));
        this.results.innerHTML = res ? res.outerHTML : '';
        this.classList.toggle('predictive-active', !!res);
        Wishlist.paint(this.results);
      } catch (e) {
        if (e.name !== 'AbortError') this.results.innerHTML = '';
      }
    }
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      const load = async () => {
        this.loaded = true;
        try {
          const next = $('product-recommendations', parseHTML(await fetch(this.dataset.url).then((r) => r.text())));
          if (next && next.innerHTML.trim()) {
            this.innerHTML = next.innerHTML;
            Wishlist.paint(this);
          }
        } catch (e) {
          /* none */
        }
      };
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        load();
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }

  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.msgs = [...this.children];
      if (this.msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0;
      this.timer = setInterval(() => {
        if (this.matches(':hover')) return;
        const cur = this.msgs[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-out');
        setTimeout(() => cur.classList.remove('is-out'), 500);
        i = (i + 1) % this.msgs.length;
        this.msgs[i].classList.add('is-active');
      }, (Number(this.dataset.interval) || 4) * 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 8);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.slide', this);
      this.dots = $$('[data-slide]', this);
      this.ui = $('[data-hero-ui]', this);
      this.cur = 0;
      if (this.slides.length < 2) return;
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.slide), true)));
      $$('[data-slide-step]', this).forEach((b) => b.addEventListener('click', () => this.go(this.cur + Number(b.dataset.slideStep), true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.stop());
      let x0 = null;
      this.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) this.go(this.cur + (dx < 0 ? 1 : -1), true);
        x0 = null;
      });
      this.go(0);
      this.play();
    }
    go(n, user) {
      this.cur = (n + this.slides.length) % this.slides.length;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.cur));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.cur));
      this.ui?.classList.toggle('is-light', this.slides[this.cur].dataset.slideTheme === 'light');
      if (user) this.play();
    }
    play() {
      this.stop();
      if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.go(this.cur + 1), (Number(this.dataset.interval) || 6) * 1000);
    }
    stop() {
      clearInterval(this.timer);
    }
    disconnectedCallback() {
      this.stop();
    }
  }

  class CountDown extends HTMLElement {
    connectedCallback() {
      let end;
      const raw = (this.dataset.end || '').trim();
      if (raw) end = new Date(raw.replace(' ', 'T'));
      if (!end || isNaN(end)) {
        end = new Date();
        end.setHours(24, 0, 0, 0);
        end.setDate(end.getDate() + (Number(this.dataset.rollingDays) || 2) - 1);
      }
      const nums = Object.fromEntries($$('[data-t]', this).map((el) => [el.dataset.t, el]));
      const tick = () => {
        const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const v = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
        Object.entries(v).forEach(([k, n]) => nums[k] && (nums[k].textContent = String(n).padStart(2, '0')));
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      $$('[data-tab]', this).forEach((tab) =>
        tab.addEventListener('click', () => {
          $$('[data-tab]', this).forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on);
          });
          $$('[data-tab-panel]', this).forEach((p) => (p.hidden = p.dataset.tabPanel !== tab.dataset.tab));
        })
      );
    }
  }

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const form = document.getElementById(this.dataset.formId);
      const box = form && $('[data-buy-box]', form);
      if (!box) return;
      this.io = new IntersectionObserver(([entry]) => {
        const on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-on', on);
        document.body.classList.toggle('has-sticky', on);
      });
      this.io.observe(box);
    }
    disconnectedCallback() {
      this.io?.disconnect();
      document.body.classList.remove('has-sticky');
    }
  }

  class PriceRange extends HTMLElement {
    connectedCallback() {
      const input = $('[data-price-range]', this);
      const label = $('[data-range-label]', this);
      if (!input || !label) return;
      const fmt = (n) => `${label.dataset.prefix} ${label.dataset.currency || ''}${Number(n).toLocaleString('en-US')}`;
      input.addEventListener('input', () => (label.textContent = fmt(input.value)));
    }
  }

  class WishList extends HTMLElement {
    connectedCallback() {
      this.render();
      document.addEventListener('wishlist:change', () => this.render());
    }
    async render() {
      const handles = Wishlist.list();
      const grid = $('[data-wishlist-grid]', this);
      const empty = $('[data-wishlist-empty]', this);
      const summary = $('[data-wishlist-summary]', this);
      if (summary) {
        summary.textContent = handles.length
          ? (handles.length === 1 ? this.dataset.countOne : this.dataset.countOther).replace('[count]', handles.length)
          : this.dataset.emptyText;
      }
      empty.hidden = handles.length > 0;
      const cards = await Promise.all(
        handles.map(async (h) => {
          try {
            const html = await fetch(`${routes.root.replace(/\/$/, '')}/products/${encodeURIComponent(h)}?section_id=wishlist-card`).then((r) => (r.ok ? r.text() : ''));
            return $('.card', parseHTML(html));
          } catch (e) {
            return null;
          }
        })
      );
      grid.innerHTML = '';
      cards.filter(Boolean).forEach((c) => grid.appendChild(document.importNode(c, true)));
      Wishlist.paint(grid);
    }
  }

  const define = (name, ctor) => customElements.get(name) || customElements.define(name, ctor);
  define('quantity-input', QuantityInput);
  define('media-gallery', MediaGallery);
  define('variant-picker', VariantPicker);
  define('predictive-search', PredictiveSearch);
  define('product-recommendations', ProductRecommendations);
  define('announcement-rotator', AnnouncementRotator);
  define('sticky-header', StickyHeader);
  define('slide-show', SlideShow);
  define('count-down', CountDown);
  define('collection-tabs', CollectionTabs);
  define('sticky-atc', StickyAtc);
  define('price-range', PriceRange);
  define('wish-list', WishList);

  /* ---------- Init ---------- */
  const init = (root = document) => {
    $$('select[data-default]', root).forEach((s) => s.dataset.default && (s.value = s.dataset.default));
    const cols = store.get('vd-cols', null);
    if (cols) {
      $$('[data-collection-grid]', root).forEach((g) => g.style.setProperty('--user-cols', cols));
      $$('[data-cols]', root).forEach((b) => b.classList.toggle('is-active', b.dataset.cols === String(cols)));
    }
    Wishlist.paint(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.id === 'shopify-section-cart-drawer') Drawers.open('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.id === 'shopify-section-cart-drawer') Drawers.close(false);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.slide');
    const show = slide?.closest('slide-show');
    if (show) {
      show.stop();
      show.go(show.slides.indexOf(slide));
    }
  });
})();
